import { PlayerModel } from "./Player";

export class TeamModel{
    public name: string = '';
    public shortName: string = '';
    public abbrName: string = '';
    public get abbr(): string {
        return typeof this.abbrName !== 'undefined' && this.abbrName !== null ? this.abbrName.toLowerCase() : '';
    }
    public get abbrU(): string {
        return typeof this.abbrName !== 'undefined' && this.abbrName !== null ? this.abbrName.toUpperCase() : '';
    }
    constructor(obj?: any) {
        if (obj) {
        }
    }
    public players: PlayerModel[] = [];
}